import { render, staticRenderFns } from "./vehicleDetailInfo.vue?vue&type=template&id=f7b1bc54&scoped=true&"
import script from "./vehicleDetailInfo.vue?vue&type=script&lang=js&"
export * from "./vehicleDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b1bc54",
  null
  
)

export default component.exports